import React from "react";
import { DottedGradient } from "../Textures/DottedGradient";
import classNames from "classnames";
import { RoomLogo } from "../RoomLogo/RoomLogo";
import { FaHandPointer } from "react-icons/fa";
import "./workexperience.css";
import { useTranslation } from "react-i18next";

export function Cover({ coverPath, themeKey }) {
  const { t } = useTranslation();
  return (
    <div className={classNames("slide", { "slide-dark": themeKey === "dark" })}>
      <div className="we-logo-container">
        <RoomLogo className="we-logo" />
        <div className="we-swipe-container">
          <h4>{t("actions.swipe")}</h4>
          <FaHandPointer />
        </div>
      </div>
      <img src={coverPath} alt="cover" className="we-cover-img" />
      <div className="dotted-bg">
        <DottedGradient color={themeKey === "dark" ? "#051936" : "#dfe7ed"} />
      </div>
    </div>
  );
}
